<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>基础设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formBody">
        <el-form ref="form" :model="userData" label-width="120px">
            <el-form-item label="注册送">
                <el-input v-model="userData.regGive" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="邀请注册奖励">
                <el-input v-model="userData.regBack" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="邀请奖励">
                <el-input v-model="userData.invitePercent" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="生命大使">
                <el-input v-model="userData.needFrozen" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="转账手续费">
                <el-input v-model="userData.sendFee" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="释放比例">
                <el-input v-model="userData.releasePer" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="团队数">
                <el-input v-model="userData.nowTeam" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="最大团队数">
                <el-input v-model="userData.maxTeam" :disabled="disaBieBtn"></el-input>
            </el-form-item>
            <el-form-item label="是否能新增团队">
              <el-radio-group v-model="userData.canAddTeam" @input="changeRadio" :disabled="disaBieBtn">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
                <el-tag type="success">
                  当前状态：{{userData.canAddTeam == 0?'否':'是'}}
                </el-tag>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit" v-if="disaBieBtn">修改系统设置</el-button>
                <el-button type="primary" @click="onOKSubmit" :loading="loading" v-else>确认修改</el-button>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { adminSet, adminChangeSet, deptDelete } from '../../api/userMG'
export default {
  data() {
    return {
      loading: false,
      userData: {
        regGive: '',
        regBack:'',
        invitePercent:'',
        needFrozen:'',
        sendFee:'',
        releasePer:'',
        nowTeam:'',
        canAddTeam:'',
        maxTeam:''
      },
      disaBieBtn: true
    }
  },
  // 注册组件
  components: {
    
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      adminSet().then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data[0]
        }
      })
      .catch(err => {
        this.editFormVisible = false
        this.loading = false
        this.$message.error('请稍后再试！')
      })
    },
    changeRadio(e) {
      this.userData.canAddTeam = e;
    },
    onSubmit() {
      this.disaBieBtn = false;
    },
    onOKSubmit() {
      this.loading = true
      adminChangeSet(this.userData).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.getdata();
          this.disaBieBtn = false;
          this.$message({
            type: 'success',
            message: '修改成功'
          })
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('请稍后再试！')
      })
    },
    onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      })
    }
  }
}
</script>

<style scoped>
.formBody{
    margin-top: 40px;
}
.line{
  text-align: center;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/adminSet/basicSet.vue